export default "__VITE_ASSET__B6TB7elr__"